module.exports = __webpack_public_path__ + "img/document_g.a35cc0b7.svg";